/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

var Rectangle = require('./Rectangle');

Rectangle.Area = require('./Area');
Rectangle.Ceil = require('./Ceil');
Rectangle.CeilAll = require('./CeilAll');
Rectangle.CenterOn = require('./CenterOn');
Rectangle.Clone = require('./Clone');
Rectangle.Contains = require('./Contains');
Rectangle.ContainsPoint = require('./ContainsPoint');
Rectangle.ContainsRect = require('./ContainsRect');
Rectangle.CopyFrom = require('./CopyFrom');
Rectangle.Decompose = require('./Decompose');
Rectangle.Equals = require('./Equals');
Rectangle.FitInside = require('./FitInside');
Rectangle.FitOutside = require('./FitOutside');
Rectangle.Floor = require('./Floor');
Rectangle.FloorAll = require('./FloorAll');
Rectangle.FromPoints = require('./FromPoints');
Rectangle.GetAspectRatio = require('./GetAspectRatio');
Rectangle.GetCenter = require('./GetCenter');
Rectangle.GetPoint = require('./GetPoint');
Rectangle.GetPoints = require('./GetPoints');
Rectangle.GetSize = require('./GetSize');
Rectangle.Inflate = require('./Inflate');
Rectangle.MarchingAnts = require('./MarchingAnts');
Rectangle.MergePoints = require('./MergePoints');
Rectangle.MergeRect = require('./MergeRect');
Rectangle.MergeXY = require('./MergeXY');
Rectangle.Offset = require('./Offset');
Rectangle.OffsetPoint = require('./OffsetPoint');
Rectangle.Overlaps = require('./Overlaps');
Rectangle.Perimeter = require('./Perimeter');
Rectangle.PerimeterPoint = require('./PerimeterPoint');
Rectangle.Random = require('./Random');
Rectangle.Scale = require('./Scale');
Rectangle.Union = require('./Union');

module.exports = Rectangle;



//////////////////
// WEBPACK FOOTER
// ./geom/rectangle/index.js
// module id = 319
// module chunks = 0